import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Overlay,
  Popover,
  Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import Flatpickr from "react-flatpickr";
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchCountry, selectCountry } from "../../redux/actions/countryAction";
import { useDispatch, useSelector } from "react-redux";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { fetchGenders, selectGender } from "../../redux/actions/genderActions";
import axios from "../../API/axios";
import moment from "moment";
import toast from "react-hot-toast";
import {
  fetchInstituteData,
  selectGetInstitute,
} from "../../redux/actions/getInstitutesAction";
import { useParams } from "react-router-dom";
import {
  fetchDesignation,
  selectDesignation,
} from "../../redux/actions/designationAction";
import {
  fetchCompanyData,
  selectGetCompanies,
} from "../../redux/actions/getCompaniesAction";
import { fetchLanguage } from "../../redux/actions/LanguageAction";

const UpdateResume = ({ show, handleClose, userDataInfo }) => {
  console.log("userDataInfo", userDataInfo);

  const sessionId = localStorage.getItem("sessionId");
  const userUID = localStorage.getItem("userUID");

  // ...............................language DDL.......................................

  const [language, setLanguage] = useState([]);
  const dispatch = useDispatch();
  const { LanguageList, selectedLanguageId } = useSelector(
    (state) => state.language
  );
  console.log("language", LanguageList);

  useEffect(() => {
    dispatch(fetchLanguage());
  }, [dispatch]);

  const handleLanguageSelect = (selectedOption) => {

    setLanguage(selectedOption.value);

  };
  // ...............................language DDL.......................................


  // ...............................Gender DDL.......................................

  const [genderValue, setGenderValue] = useState("");
  // const dispatch = useDispatch();
  const { genderOptions, selectedGender } = useSelector(
    (state) => state.gender
  );
  // console.log("selectedGender", genderOptions, selectedGender);

  useEffect(() => {
    dispatch(fetchGenders());
  }, [dispatch]);
  const handleGenderSelect = (selectedOption) => {
    if (selectedOption) {
      setGenderValue(selectedOption.value);
      // dispatch(selectGender(selectedOption.value));
    }
  };
  // ...............................Gender DDL.......................................

  // ...............................City DDL.......................................

  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  const [cityId, setcityId] = useState("");
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      //   dispatch(selectCity(selectedOption.value));
      setcityId(selectedOption.value);
    }
  };

  // ...............................City DDL.......................................

  // ...............................PROFILE Start.......................................
  const [displays, setDisplays] = useState(false);
  const [displays1, setDisplays1] = useState(false);
  const [langValue, setLangValue] = useState("");
  const [cityValue, setCitValue] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageview, setProfileImageview] = useState("");
  const [aboutValue, setAboutValue] = useState("");
  const [website, setWebsite] = useState("");
  const [curretactive, setCurretactive] = useState("");
  const [headLine, setHeadLine] = useState("");
  const [about, setAbout] = useState("");
  const [orgType, setOrgType] = useState("");
  const { CandidateId } = useParams();

  const handleProfileImageChange = (event) => {
    const selectedFile = event.target.files[0];
    setProfileImage(selectedFile);
    setProfileImageview(URL.createObjectURL(selectedFile));
  };
  const Profile = async (e) => {
    e.preventDefault();
    try {
      setDisplays(true);
      if (
        // language &&
        genderValue &&
        cityId &&
        // startDate &&
        profileImage !== ""
      ) {
        const formData = new FormData();
        // formData.append("LangId", language);
        // formData.append("GndrId", genderValue);
        formData.append("CityId", cityId);
        // formData.append(
        //   "Dob",
        //   startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
        // );
        formData.append("ProfileImage", profileImage);
        formData.append("sessionId", sessionId);
        const res = await axios.post(
          "/Account/UpdateCandidateProfile",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("get data", res);
        toast.success(res.data.message);
        setDisplays(false);
      } else {
        toast.error("please enter required fields!");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  const UpdateProfile = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    try {
      setDisplays(true);

      // Input validation (same logic as AddProfile)
      if (!curretactive || !orgType) {
        toast.error("Please fill all required fields.");
        return;
      }

      if (orgType === "1" && !instituteId && !headLine && !website && !about) {
        toast.error("Please select an Institution.");
        return;
      } else if (orgType !== "1") {
        if (!companyId && !designationId && !headLine && !website && !about) {
          toast.error("Please fill all required fields.");
          return;
        }
      }

      let body = {
        sessionId: sessionId,
        currentlyActiveAs: curretactive,
        orgType: String(orgType),
      };
      console.log("orgType (should be string):", body.orgType);

      if (orgType === "1") {
        body.insttnId = instituteId;
        body.compId = null;
        body.dsgntnId = null;
        body.headLine = headLine;
        body.about = about;
        body.website = website;
      } else {
        body.insttnId = null;
        body.compId = companyId;
        body.dsgntnId = designationId;
        body.headLine = headLine;
        body.about = about;
        body.website = website;
      }
      console.log("body", body);
      // API request to update the profile
      const res = await axios.post("/CandidateData/Update", body);

      console.log("Update Response:", res);

      // Show success message and reset form fields
      toast.success(res.data.message);
      setCompanyId("");
      setInstituteId("");
      setHeadLine("");
      setWebsite("");
      setAbout("");
      setDisplays(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };
  // ...............................PROFILE End.......................................
  // ...............................PROFILE Institute Start.......................................
 

  const InstituteProfile = async (e) => {
    e.preventDefault();
    try {
      setDisplays(true);

      // Extract language IDs as a comma-separated string
      // const multiLang = language ? language.map((option) => option.value) : [];
      // console.log("multiLang (to be appended):", multiLang);

      if (genderValue && cityId && startDate !== "") {
        const formData = new FormData();
        formData.append("InsttCnddtId", CandidateId);
        // formData.append("LangId", multiLang.join(",")); // Append the correct string
        formData.append("GndrId", genderValue);
        formData.append("CityId", cityId);
        formData.append(
          "Dob",
          startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
        );
        formData.append("sessionId", sessionId);

        // Log FormData for debugging
        for (let pair of formData.entries()) {
          console.log(pair[0] + ": " + pair[1]);
        }

        const res = await axios.post(
          "/Account/UpdateCandidateProfileByInstitute",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Response Data:", res);
        toast.success(res.data.message);
        setDisplays(false);
      } else {
        toast.error("Please enter required fields!");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  const UpdateProfileInstitute = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    try {
      // setDisplays(true);

      // Input validation (same logic as AddProfile)
      if (!curretactive || !orgType) {
        toast.error("Please fill all required fields.");
        return;
      }

      if (orgType === "1" && !instituteId && !headLine && !website && !about) {
        toast.error("Please select an Institution.");
        return;
      } else if (orgType !== "1") {
        if (!companyId && !designationId && !headLine && !website && !about) {
          toast.error("Please fill all required fields.");
          return;
        }
      }

      let body = {
        sessionId: sessionId,
        currentlyActiveAs: curretactive,
        orgType: String(orgType),
      };
      console.log("orgType (should be string):", body.orgType);

      if (orgType === "1") {
        body.insttnId = instituteId;
        body.compId = null;
        body.dsgntnId = null;
        body.headLine = headLine;
        body.about = about;
        body.website = website;
      } else {
        body.insttnId = "null";
        body.compId = companyId;
        body.dsgntnId = designationId;
        body.headLine = headLine;
        body.about = about;
        body.website = website;
      }
      console.log("body", body);
      // API request to update the profile
      const res = await axios.post("/CandidateData/UpdateByInstitute", body);

      console.log("Update Response:", res);

      // Show success message and reset form fields
      toast.success(res.data.message);
      setCompanyId("");
      setInstituteId("");
      setHeadLine("");
      setWebsite("");
      setAbout("");
      // setDisplays(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // ...............................PROFILE Institute End.......................................

  useEffect(() => {
    if (userDataInfo) {
      setStartDate(userDataInfo?.dob);
      setCitValue(userDataInfo?.currentCityId);
      setProfileImageview(userDataInfo?.userImage);
    }
  }, []);

  // .............................. designation Dropdown ...............................

  const [designationSearch, setDesignationSearch] = useState("");
  const [designationId, setDesignationId] = useState("");
  const { designationList, selectedDesignationId } = useSelector(
    (state) => state.designation
  );
  useEffect(() => {
    dispatch(fetchDesignation());
  }, [dispatch]);
  const handleDesignation = (selectedOption) => {
    if (selectedOption) {
      //   dispatch(selectDesignation(selectedOption.value));
      setDesignationId(selectedOption.value);
    }
  };
  // ...............................Designation Dropdown.......................................

  // // ...............................Institute Dropdown.......................................
  const [instituteSearch, setInstituteSearch] = useState("");
  const [instituteId, setInstituteId] = useState(null);
  const { getinstituteList, selectedinstituteId } = useSelector(
    (state) => state.institute
  );
  useEffect(() => {
    dispatch(fetchInstituteData());
  }, [dispatch]);

  const handleInstitute = (selectedOption) => {
    if (selectedOption) {
      //   dispatch(selectGetInstitute(selectedOption.value));
      setInstituteId(selectedOption.value);
    }
  };
  // // ...............................Institute Dropdown.......................................

  // ...............................Company Dropdown.......................................
  const [companySearch, setCompanySearch] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const { getcompaniesList, selectedcompaniesId } = useSelector(
    (state) => state.getcompanies
  );
  // console.log('companies',getcompaniesList,selectedcompaniesId);

  useEffect(() => {
    dispatch(fetchCompanyData());
  }, [dispatch]);

  const handleCompany = (selectedOption) => {
    if (selectedOption) {
      //   dispatch(selectGetCompanies(selectedOption.value));
      setCompanyId(selectedOption.value);
    }
  };
  // ...............................company Dropdown.......................................

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header>
        <Modal.Title>Profile</Modal.Title>
        <CloseSharpIcon className="pointer" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="settings">
        <div className="mb-3">
          <h5 className="fw-bold border-custom d-inline">User Profile</h5>
        </div>

        <div className="profile-setting-form">

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="gender">
                Gender{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <ReactSelect
                options={genderOptions}
                onChange={handleGenderSelect}
                value={
                  genderOptions.find(
                    (option) => option.value === genderValue
                  ) || null
                }
                placeholder="Select Gender"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
              />
              {displays && !genderValue ? (
                <span className="error_msg_lbl text-red">Enter Gender </span>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="city">
                City{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <ReactSelect
                options={cityList}
                onChange={handleCitySelect}
                value={
                  cityList.find((option) => option.value === cityId) || null
                }
                placeholder="Select city"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
              />

              {displays && !cityId ? (
                <span className="error_msg_lbl text-red">Enter City </span>
              ) : null}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="lastName">
                Profile Image{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <input
                type="file"
                id="lastName"
                className="form-control  Dark-Input-from-group"
                placeholder=""
                required
                onChange={(e) => {
                  handleProfileImageChange(e);
                }}
                // value={profileImage}
                invalid={displays && profileImage === ""}
              />

              {displays && !profileImage ? (
                <span className="error_msg_lbl text-red">Enter Language </span>
              ) : null}
            </div>
            <div className="form-group">
              <img src={profileImageview} width={200} height={200} />
            </div>
          </div>
          <div className="text-end">
            <button
              className="btn btn-primary"
              onClick={async (e) => {
                if (CandidateId === "Candidate") {
                  Profile(e);
                } else {
                  InstituteProfile(e);
                }
              }}
            >
              Update
            </button>
          </div>
        </div>
        <hr />
        <div className="mb-3">
          <h5 className="fw-bold border-custom d-inline">User Info</h5>
        </div>
        {/* <div className="profile-setting-form">
                    <div className="post-form-row">
                        <div className="post-form-group">
                            <label htmlFor="jobApplyType">Institution <span style={{ color: "red" }} className="ms-2">*</span></label>
                            <ReactSelect
                                options={getinstituteList}
                                onChange={handleInstitute}
                                value={getinstituteList.find(option => option.value === instituteId) || null}
                                placeholder="Select Institute Type"
                                styles={customStyles}
                                classNamePrefix="react-select"
                                className="form-control"
                                onInputChange={(inputValue) => setInstituteSearch(inputValue)}
                                invalid={displays && instituteSearch === ""}
                            />
                            {displays && !selectedinstituteId ? <span className='error_msg_lbl text-red'>Enter Institution</span> : null}
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="headline">Headline <span style={{ color: "red" }} className="ms-2">*</span></label>
                            <input type="text"
                                value={headline}
                                onChange={(e) => {
                                    setHeadline(e.target.value)
                                }}
                            />
                            {displays1 && !headline ? <span className='error_msg_lbl text-red'>Enter Headline </span> : null}
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="website">Website <span style={{ color: "red" }} className="ms-2">*</span></label>
                            <input type="text"
                                value={website}
                                onChange={(e) => {
                                    setWebsite(e.target.value)
                                }} />
                            {displays1 && !website ? <span className='error_msg_lbl text-red'>Enter Website </span> : null}
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="about">About <span style={{ color: "red" }} className="ms-2">*</span></label>
                            <textarea className="form-control"
                                required
                                onChange={(e) => setAboutValue(e.target.value)}
                                value={aboutValue}
                            ></textarea>
                            {displays1 && !aboutValue ? <span className='error_msg_lbl text-red'>Enter About </span> : null}
                        </div>
                    </div>

                    <div className="text-end">
                        <button className="btn btn-primary"
                            onClick={(e) => {
                                if (CandidateId === 'Candidate') {
                                    ProfileBasic(e);
                                } else {
                                    ProfileInstituteBasic(e);
                                }
                            }}
                        >
                            Update</button>
                    </div>
                </div> */}
        {/* <div className="card delete-card  d-flex align-center"> */}
        <div className="post-job-details-form Edit-Card-details-form">
          <div className="post-form-row">
            <div className="post-form-group">
              <label htmlFor="category">Currently Active</label>
              <select
                id="currentactive"
                className="form-control Dark-Input-from-group"
                placeholder="value"
                required
                onChange={(e) => setCurretactive(e.target.value)}
                value={curretactive}
                invalid={displays && curretactive === ""}
              >
                <option value="Default Value">Select here</option>
                <option value="1">Student</option>
                <option value="2">Professional</option>
              </select>
              {displays && !curretactive ? (
                <span className="error_msg_lbl text-red">
                  Enter Currently Active
                </span>
              ) : null}
            </div>

            <div className="post-form-group">
              <label htmlFor="tag">Organization Type</label>
              <select
                className="form-control Dark-Input-from-group"
                onChange={(e) => setOrgType(e.target.value)}
                value={orgType}
                id="Orgtype"
                placeholder="Organization Type"
                required
                styles={customStyles}
                invalid={displays && orgType === ""}
              >
                <option value="Default Value">Select here</option>
                <option value="1">Institution</option>
                <option value="2">Company</option>
              </select>

              {displays && !orgType ? (
                <span className="error_msg_lbl text-red">
                  Enter Organization Type
                </span>
              ) : null}
            </div>
          </div>

          {/* Conditionally render additional fields based on organization type */}
          {orgType && (
            <div>
              {orgType === "1" ? (
                <>
                  <div className="post-form-row">
                    <div className="post-form-group">
                      <label htmlFor="jobApplyType">Institution</label>
                      <ReactSelect
                        options={getinstituteList}
                        onChange={handleInstitute}
                        value={
                          getinstituteList.find(
                            (option) => option.value === instituteId
                          ) || null
                        }
                        placeholder="Select Institute Type"
                        styles={customStyles}
                        classNamePrefix="react-select"
                        className="form-control"
                        onInputChange={(inputValue) =>
                          setInstituteSearch(inputValue)
                        }
                        invalid={displays && instituteSearch === ""}
                      />
                      {displays && !instituteId ? (
                        <span className="error_msg_lbl text-red">
                          Enter Institution
                        </span>
                      ) : null}
                    </div>
                    <div className="post-form-group">
                      <label htmlFor="minSalary">HeadLine</label>
                      <input
                        type="text"
                        id="minSalary"
                        placeholder="HeadLine"
                        required
                        onChange={(e) => setHeadLine(e.target.value)}
                        value={headLine}
                        invalid={displays && headLine === ""}
                      />
                      {displays && !headLine ? (
                        <span className="error_msg_lbl text-red">
                          Enter HeadLine
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div className="post-form-row">
                    <div className="post-form-group">
                      <label htmlFor="experience">Website</label>
                      <input
                        type="text"
                        id="experience"
                        placeholder="Website"
                        onChange={(e) => setWebsite(e.target.value)}
                        value={website}
                        invalid={displays && website === ""}
                      />
                      {displays && !website ? (
                        <span className="error_msg_lbl text-red">
                          Enter Website
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div className="post-form-row">
                    <div className="post-form-group">
                      <label htmlFor="maxSalary">About</label>
                      <textarea
                        type="text"
                        id="maxSalary"
                        placeholder="About"
                        onChange={(e) => setAbout(e.target.value)}
                        value={about}
                        invalid={displays && about === ""}
                      />
                      {displays && !about ? (
                        <span className="error_msg_lbl text-red">
                          Enter About
                        </span>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="post-form-row">
                    <div className="post-form-group">
                      <label htmlFor="gender">Company</label>
                      <ReactSelect
                        options={getcompaniesList}
                        onChange={handleCompany}
                        value={
                          getcompaniesList.find(
                            (option) => option.value === companyId
                          ) || null
                        }
                        placeholder="Select Company Type"
                        styles={customStyles}
                        classNamePrefix="react-select"
                        className="form-control"
                        onInputChange={(inputValue) =>
                          setCompanySearch(inputValue)
                        }
                        invalid={displays && companySearch === ""}
                      />
                      {displays && !companyId ? (
                        <span className="error_msg_lbl text-red">
                          Enter Company
                        </span>
                      ) : null}
                    </div>

                    <div className="post-form-group">
                      <label htmlFor="externalUrl">Designation</label>
                      <ReactSelect
                        options={designationList}
                        onChange={handleDesignation}
                        value={
                          designationList.find(
                            (option) => option.value === designationId
                          ) || null
                        }
                        placeholder="Select Designation Type"
                        styles={customStyles}
                        classNamePrefix="react-select"
                        className="form-control"
                        onInputChange={(inputValue) =>
                          setDesignationSearch(inputValue)
                        }
                        invalid={displays && designationSearch === ""}
                      />
                      {displays && !designationId ? (
                        <span className="error_msg_lbl text-red">
                          Enter Designation
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div className="post-form-row">
                    <div className="post-form-group">
                      <label htmlFor="minSalary">HeadLine</label>
                      <input
                        type="text"
                        id="minSalary"
                        placeholder="HeadLine"
                        required
                        onChange={(e) => setHeadLine(e.target.value)}
                        value={headLine}
                        invalid={displays && headLine === ""}
                      />
                      {displays && !headLine ? (
                        <span className="error_msg_lbl text-red">
                          Enter HeadLine
                        </span>
                      ) : null}
                    </div>
                    <div className="post-form-group">
                      <label htmlFor="experience">Website</label>
                      <input
                        type="text"
                        id="experience"
                        placeholder="Website"
                        onChange={(e) => setWebsite(e.target.value)}
                        value={website}
                        invalid={displays && website === ""}
                      />
                      {displays && !website ? (
                        <span className="error_msg_lbl text-red">
                          Enter Website
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div className="post-form-row">
                    <div className="post-form-group">
                      <label htmlFor="maxSalary">About</label>
                      <textarea
                        type="text"
                        id="maxSalary"
                        placeholder="About"
                        onChange={(e) => setAbout(e.target.value)}
                        value={about}
                        invalid={displays && about === ""}
                      />
                      {displays && !about ? (
                        <span className="error_msg_lbl text-red">
                          Enter About
                        </span>
                      ) : null}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          <div className="avatar-upload-container">
            <button
              className="save-button"
              onClick={(e) => {
                if (CandidateId === "Candidate") {
                  UpdateProfile(e);
                } else {
                  UpdateProfileInstitute(e);
                }
              }}
            >
              Save
            </button>
          </div>
        </div>

        {/* </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default UpdateResume;
